import { useGlobalStore } from "@/store/GlobalStore";
import {
  AvatarIcon,
  UserInfoLeftWrapper,
  UserInfoWrapper,
  UserMemberExpired,
  UserMemberInfo,
  UserMemberWrapper,
  UserInfoContent,
  MemberIcon,
  UserAccountBalance,
  UserAccountCredit,
  CreditLabel,
  CreditValue,
  Separator,
  CurrencySymbol,
  CurrencyNumber,
  UserAccountWrapper,
} from "./atom";
import { IsMemberIcon, NotMemberIcon } from "../../icons";
import { ChargeType } from "../../constants";
import { useClientTopUpStore } from "../../store";
import dayjs from "dayjs";

const UserInfo = () => {
  const { userInfo, userCredit, isHideBalance, isShowCreditTotal } =
    useGlobalStore();
  const { activeBar } = useClientTopUpStore();
  const VIPExpireDate = userInfo?.picMemberValidity;
  const isPicMember = userInfo?.pictureLever;

  return (
    <UserInfoWrapper>
      <UserInfoLeftWrapper>
        <UserInfoContent>
          <AvatarIcon>
            <div>{userInfo?.userName?.substring(0, 1).toUpperCase()}</div>
          </AvatarIcon>
          <UserMemberWrapper>
            <UserMemberInfo>
              <div>{userInfo?.userName}</div>
              <MemberIcon isMember={isPicMember}>
                {isPicMember ? <IsMemberIcon /> : <NotMemberIcon />}
                <span>效果图会员</span>
              </MemberIcon>
            </UserMemberInfo>
            <UserMemberExpired>
              {isPicMember
                ? dayjs(VIPExpireDate).format("YYYY.MM.DD") + "到期"
                : "开通会员尊享更多权益"}
            </UserMemberExpired>
          </UserMemberWrapper>
        </UserInfoContent>
        {activeBar === ChargeType.Recharge && (
          <UserAccountWrapper>
            <UserAccountBalance>
              <CreditLabel>账户余额</CreditLabel>
              <CreditValue>
                <CurrencySymbol>¥</CurrencySymbol>
                <CurrencyNumber>{userInfo?.rmbbalance}</CurrencyNumber>
              </CreditValue>
            </UserAccountBalance>
            {(isShowCreditTotal || userCredit !== 0) && !isHideBalance && (
              <UserAccountCredit>
                <CreditLabel>
                  可用额度
                  <Separator />
                  总额度
                </CreditLabel>
                <CreditValue>
                  <CurrencySymbol>¥</CurrencySymbol>
                  <CurrencyNumber>{userCredit}</CurrencyNumber>
                  <Separator height={12} />
                  <CurrencySymbol>¥</CurrencySymbol>
                  <CurrencyNumber>{userInfo?.totalCredit}</CurrencyNumber>
                </CreditValue>
              </UserAccountCredit>
            )}
          </UserAccountWrapper>
        )}
      </UserInfoLeftWrapper>
    </UserInfoWrapper>
  );
};

export default UserInfo;
